import { render, staticRenderFns } from "./BrigadaPuesto.vue?vue&type=template&id=e5d29934&"
import script from "./BrigadaPuesto.vue?vue&type=script&lang=js&"
export * from "./BrigadaPuesto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports